// Some producers return JSON-schema descriptions wrapped in a structured XML format
// like:
//   <root>
//     <div><label>description</label>:<b>Actual description text</b></div>
//     <div><label>businessTerm</label>:<b>...</b></div>
//   </root>
// The form fields render `schema.description` directly as the placeholder, so this
// markup leaks into the UI. This helper detects the wrapped format and extracts the
// `description` label's value, falling back to `businessTerm` when the producer left
// `description` empty (some elements only fill businessTerm/businessDefinition). Before
// this fallback, an empty `description` dropped through to the tag-strip path below and
// leaked the whole "description:businessTerm:...dataFormat:NA" concatenation into the
// placeholder. For any other HTML-tainted string it falls back to a plain tag strip.
// Plain text is returned unchanged.
//
// NOTE: `resolveDescription` in EFormV2/InfoIcon.jsx applies the same
// description->businessTerm precedence for tooltips; keep the two in sync.

const WRAPPED_LABEL_RE = /<label>([^<]+)<\/label>[^<]*<b>([^<]*)<\/b>/gi
const HTML_TAG_RE = /<\/?[a-z][^>]*>/gi
const WHITESPACE_RUN_RE = /\s+/g

function parseWrappedLabels(value) {
	const fields = {}
	WRAPPED_LABEL_RE.lastIndex = 0
	let match
	while ((match = WRAPPED_LABEL_RE.exec(value)) !== null) {
		fields[match[1].trim().toLowerCase()] = match[2].trim()
	}
	return fields
}

function cleanDescription(value) {
	if (typeof value !== 'string' || value.length === 0) return value
	if (!value.includes('<')) return value

	if (/<label>/i.test(value)) {
		const fields = parseWrappedLabels(value)
		return fields.description || fields.businessterm || ''
	}

	return value.replace(HTML_TAG_RE, '').replace(WHITESPACE_RUN_RE, ' ').trim()
}

export { cleanDescription }
